import { css } from '@emotion/css';

import { cn } from '@lyearn/style';
import {
  cardSizeMobileStyles,
  cardSizeStyles,
} from '@/modules/content/components/ContentCard/styles';

export const MINI_CARD_PADDING = 8;

export const MINI_CARD_IMAGE_WIDTH = 10.4;
export const MINI_CARD_IMAGE_HEIGHT = 11.6;
export const MINI_CARD_MOBILE_IMAGE_WIDTH = 6.4;
export const MINI_CARD_MOBILE_IMAGE_HEIGHT = 6.4;

export const MINI_CARD_SIZE = {
  default: {
    height: 13.2,
    width: 37.6,
  },
  mobile: {
    height: 11.2,
    width: 36.4,
  },
};

export const miniCardSizeStyles = cn(
  cardSizeStyles(MINI_CARD_SIZE.default),
  cardSizeMobileStyles(MINI_CARD_SIZE.mobile),
);

export const miniCardMobileStyles = cardSizeMobileStyles(MINI_CARD_SIZE.mobile);

export const imageStyles = css`
  width: ${MINI_CARD_IMAGE_WIDTH}rem;
  height: ${MINI_CARD_IMAGE_HEIGHT}rem;
`;

export const imageMobileStyles = css`
  width: ${MINI_CARD_MOBILE_IMAGE_WIDTH}rem;
  height: ${MINI_CARD_MOBILE_IMAGE_HEIGHT}rem;
`;

export const imageContainerStyles = css`
  border-radius: 1.2rem;
`;
